<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12" class="mb-3">
          <b-button variant="primary" @click="$router.go(-1)" class="pull-left back-btn">Terug</b-button>
        </b-col>
        <b-col cols="12">

          <b-form @submit.prevent="updateData">
          <b-card no-body>
            <template v-slot:header>
              <span class="pull-left mt-2 mb-2">{{item.name}}</span>
            </template>
            <b-tabs pills card>
              <b-tab title="Details" active>
                <b-col cols="12" class="mt-2">

                  <b-form-group label="Directe link">
                    <b-form-input type="text" required v-model="item.url" readonly></b-form-input>
                  </b-form-group>
                  <b-form-group label="Status">
                    <b-form-select :options="statusOptions" required v-model="item.status" :disabled="!editable"></b-form-select>
                  </b-form-group>
                  <b-form-group label="Naam">
                    <b-form-input type="text" required v-model="item.name" :disabled="!editable"></b-form-input>
                  </b-form-group>
                  <b-form-group label="Titel">
                    <b-form-input type="text" required v-model="item.title" :disabled="!editable"></b-form-input>
                  </b-form-group>
                  <b-form-group label="Datum">
                    <b-form-input type="date" required v-model="item.published_at" :disabled="!editable"></b-form-input>
                  </b-form-group>
                  <b-form-group label="Korte beschrijving">
                    <b-form-input type="text" required v-model="item.intro" :disabled="!editable"></b-form-input>
                  </b-form-group>

                  <b-form-group label="Inhoud">

                    <ckeditor
                      v-model="item.content"
                      :disabled="!editable"
                      :editor="editor"
                      :config="editorConfig"
                      required />

                  </b-form-group>
                </b-col>
              </b-tab>
              <b-tab title="KPI's">
                <project-upload-kpis @changedKpis="updateKpis" :kpis="item.kpis"></project-upload-kpis>
              </b-tab>
              <b-tab title="Bestanden">
                <project-update-upload v-on:uploadedFiles="updateFiles" @addedVideo="updateVideos" />
                <project-upload-documents v-on:deletedFile="removeFile" @deletedVideo="removeVideo" :images="item.attachments.images" :files="item.attachments.files" :videos="item.attachments.videos" />
              </b-tab>
            </b-tabs>

            <template v-slot:footer>
              <a class="btn btn-primary pull-left hoverable" @click="editable=true" v-if="!editable">Bewerken</a>
              <a class="btn btn-warning pull-left hoverable" @click="cancelEdit" v-if="editable">Annuleer</a>
              <b-button type="submit" variant="success" class="pull-right" v-if="editable">Opslaan</b-button>
            </template>
          </b-card>
          </b-form>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import {getData, updateData} from '@/api';
import ClassicEditor from '@/assets/ckeditor5';
import ProjectUpdateUpload from "@/views/projects/updates/parts/Upload";
import ProjectUploadDocuments from "@/views/projects/updates/parts/Documents";
import ProjectUploadKpis from "@/views/projects/updates/parts/Kpis";

export default {
  name: 'update-single',

  components: { ClassicEditor, ProjectUpdateUpload, ProjectUploadDocuments, ProjectUploadKpis},

  props: ['id'],

  data() {
    return {
      saveButtonDisabled: false,
      feedback: {
        show: false,
        text: '',
        variant: null,
        dismissCountDown: 4
      },
      editable: false,
      item: [],
      errors: null,
      editor: ClassicEditor,
      editorConfig: {
        toolbar: {
          items: [
            'heading', '|',
            'bold', 'underline', 'italic', 'strikethrough', '|',
            'fontColor', 'fontBackgroundColor', '|',
            'indent', 'outdent', '|',
            'bulletedList', 'numberedList', '|',
            'link',
          ],

          height: '500px',
        },

        indentBlock: {
          offset: 1,
          unit: 'em'
        },

        fontColor: {
          colors: [
            {
              color: 'hsl(0, 0%, 0%)',
              label: 'Black'
            },
            {
              color: 'hsl(0, 0%, 52%)',
              label: 'Dim grey'
            },
            {
              color: 'hsl(19, 98%, 53%)',
              label: 'Orange'
            }
          ]
        }
      },

      statusOptions: [
        {'value': null, 'text': 'Kies een optie...'},
        {'value': 'draft', 'text': 'Concept'},
        {'value': 'published', 'text': 'Gepubliceerd'},
      ],

    }
  },

  methods: {
    async getItem() {
      const item = await getData(`projects/${this.$route.params.id}/updates/${this.$route.params.update_id}`).then(response => response.data);
      this.item = item.data
    },

    async updateData() {
      const request = await updateData(`projects/${this.$route.params.id}/updates/${this.$route.params.update_id}`, {
        name: this.item.name,
        title: this.item.title,
        published_at: this.item.published_at,
        status: this.item.status,
        intro: this.item.intro,
        content: this.item.content,
      }).then(response => response.data);
      this.item = request.data
      this.editable = false;
    },

    cancelEdit() {
      this.getItem();
      this.editable = false;
    },

    updateKpis(data) {
      this.item.kpis = data;
    },

    updateFiles(data) {
      this.item.attachments.images = data.project_update_images;
      this.item.attachments.files = data.project_update_files;
    },

    removeFile(id) {
      this.item.attachments.images = this.item.attachments.images.filter(file => file.id != id);
      this.item.attachments.files = this.item.attachments.files.filter(file =>  file.id != id);
    },

    updateVideos(data) {
      this.item.attachments.videos = data;
    },

    removeVideo(id) {
      this.item.attachments.videos = this.item.attachments.videos.filter(video => video.id !== id);
    }
  },

  beforeMount() {
    this.getItem();
  },
}

</script>
<style>
.ck-editor__editable {
  min-height: 300px;
}

/*.ck-heading_heading2_orange span {*/
/*  color: orange !important;*/
/*}*/
</style>
